import { ProfileUpdateRequestImpl } from "shared/cubiq-model-multi-asset";
import { BfxUserSettingsComponent } from "./bfx-user-settings.component";
import { BfxUserSettingsComponentState } from "./bfx-user-settings.service";
import { QueryList } from "@angular/core";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export interface IBfxUserSettingsPageComponent {
  // set by BfxUserSettingsComponenet.afterViewChecked
  parentComponent: BfxUserSettingsComponent | null;

  initialize(): void;
  reset(): Promise<void>;
  postReset(): void;
  validate(): Promise<BfxUserSettingsValidityState>;
  save(request: ProfileUpdateRequestImpl): void;
  postSave(request: ProfileUpdateRequestImpl): void;
  onComponentStateChanged(componentState: BfxUserSettingsComponentState): void;
  onTabActivated(event: any): void;
}

export enum BfxUserSettingsValidityState {
  INVALID,
  VALID,
  ACTIVE_UNSAVEABLE,
  VALIDATE_TIMEOUT,
}

export interface IBfxUserSettingsPageSubComponent<T extends IBfxUserSettingsPageComponent>
  extends IBfxUserSettingsPageComponent {
  // set by BfxUserSettingsComponenet.afterViewChecked
  categoryComponent: T | null;
  hasDataChanged(): boolean;
}
/**
 * Abstract class that user settings page controls extend
 * in order to properly support functions of the user settings
 * window
 */
export abstract class BfxUserSettingsPageComponent implements IBfxUserSettingsPageComponent {
  constructor() {}
  /**
   * Assign this property to the active index of the @bfx/primeng tab control
   */
  public activeSubComponent: number = 0;

  /**
   * Referrence to the containing user settings component
   */
  public parentComponent: BfxUserSettingsComponent = null;

  public subComponents: QueryList<IBfxUserSettingsPageComponent> = null;

  /**
   * Called by the parent component when all page
   * properties have been resolved
   */
  public initialize(): void | Promise<void> | Promise<void[]> {}

  /**
   * Invoked from the user settings component to reset any changes to the user profile
   */
  public reset(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      resolve();
    });
  }

  /**
   * Invoked just after reset and post reset validation is done
   */
  public abstract postReset(): void;

  /**
   * Invoked from the user settings component to check the validity of the page
   */
  public validate(): Promise<BfxUserSettingsValidityState> {
    return new Promise<BfxUserSettingsValidityState>((resolve, reject) => {
      //logger.out.info(`${this.constructor.name}.validate() valid:BfxUserSettingsValidityState.${BfxUserSettingsValidityState[BfxUserSettingsValidityState.VALID]}`);
      resolve(BfxUserSettingsValidityState.VALID);
    });
  }

  /**
   * Invoked for the component page to populate it's data in the update request
   * @param request the request to populate the data with
   */
  public abstract save(request: ProfileUpdateRequestImpl): void;

  /**
   * Invoked after successful save
   */
  public postSave(request: ProfileUpdateRequestImpl): void {}

  /**
   * Invoked when the user settings component state changes
   */
  public onComponentStateChanged(componentState: BfxUserSettingsComponentState): void {}

  /**
   * Method that is bound to a @bfx/primeng tab view control's onChange event.
   * @param event propagated by @bfx/primeng tab control on change event
   */
  public onTabActivated(event: any): void {
    this.activeSubComponent = this.parentComponent.activeSubCategory = event.index;
  }
}
